<template>
  <div class="container">
    <!-- 聊天区域 -->
    <div class="chat-history" ref="chatBox">
      <div class="prompt-box">
        <h3>您可以试着这样提问本课程相关的问题</h3>
        <ul class="question-list">
          <li v-for="(item, index) in questions" :key="index" @click="handleQuickQuestion(item.text)">
            <span :class="['dot', item.color]"></span>
            {{ item.text }}
            <img src="@/assets/Stroke.png" class="arrow-icon" />
          </li>
        </ul>
      </div>

      <div
        style="margin-top: 10px"
        v-for="(msg, index) in messages"
        :key="index"
        :class="['message', `message-${msg.type}`]"
      >
        <div class="avatar">
          <img :src="msg.type === 'user' ? userAvatar : aiAvatar" />
        </div>
        <div class="content">
          <div
            v-html="msg.type === 'ai' && index === messages.length - 1 && currentAIMessage
              ? currentAIMessage
              : msg.content"
          ></div>
          <button
          v-if="msg.type === 'ai' && index === messages.length - 1 && showRefreshBtn"
          class="refresh-btn"
          @click="refreshChat"
          >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M23 4v6h-6M1 20v-6h6"/>
            <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/>
          </svg>
          </button>
          <div class="time">{{ formatTime(msg.timestamp) }}</div>
        </div>
      </div>
    </div>

    <div class="resource-row">
      <!-- VR资源 -->
      <div class="resource-block" v-if="isChatCompleted && vrList.length">
        <h3 class="section-title">🌐 VR 资源</h3>
        <div class="scroll-wrapper">
          <button class="scroll-btn left" @click="scrollResource('vr', -1)">‹</button>
          <div class="scroll-container" ref="vrScroll">
            <div class="resource-card" v-for="(item, i) in vrList" :key="i" @click="openUrl(item.path, item.title)">
              <img :src="item.img" class="card-image lazy-load" />
              <div class="card-title">{{ item.title }}</div>
            </div>
          </div>
          <button class="scroll-btn right" @click="scrollResource('vr', 1)">›</button>
        </div>
      </div>
      <!-- 视频资源 -->
      <div class="resource-block" v-if="isChatCompleted && videoList.length">
        <h3 class="section-title">🎥 视频资源</h3>
        <div class="scroll-wrapper">
          <button class="scroll-btn left" @click="scrollResource('video', -1)">‹</button>
          <div class="scroll-container" ref="videoScroll">
            <div class="resource-card" v-for="(item, i) in videoList" :key="i" @click="openUrl(item.path, item.title)">
              <img :src="item.img" class="card-image lazy-load" />
              <div class="card-title">{{ item.title }}</div>
            </div>
          </div>
          <button class="scroll-btn right" @click="scrollResource('video', 1)">›</button>
        </div>
      </div>
    </div>

    <!-- 输入 -->
    <div class="input-box">
      <textarea
        v-model="question"
        placeholder="试着输入您想了解的问题吧。输入Shift+Enter是换行哦~"
        rows="3"
        @keydown="handleKeydown"
      ></textarea>
      <div class="control">
        <button class="send-btn" @click="handleSend" :disabled="!question.trim() || isSending">
          <span v-if="!isSending">发送</span>
          <span v-else>发送中...</span>
          <img v-if="!isSending" style="width: 20px; margin-left: 10px" src="@/assets/icons/send.png" />
        </button>
      </div>
    </div>

    <p class="disclaimer">以上内容由AI大模型生成，不代表我们的态度和观点，请仔细甄别</p>

    <!-- 模态框 -->
    <div v-if="showVideo" class="modal-mask" @click.self="closeModal">
      <div class="modal-container">
        <div class="modal-header">
          <span class="modal-title">{{ currentVideoTitle }}</span>
          <div class="modal-actions">
            <button class="fullscreen-btn" @click="toggleFullscreen">
              <svg width="20" height="20" viewBox="0 0 24 24"><path d="M8 4H16V6H8V4ZM8 18H16V20H8V18ZM4 8V16H6V8H4ZM18 8V16H20V8H18Z" fill="currentColor"/></svg>
            </button>
            <button class="close-btn" @click.stop="closeModal">
              <svg width="20" height="20" viewBox="0 0 24 24"><path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2"/></svg>
            </button>
          </div>
        </div>
        <div class="modal-content">
          <div v-if="modalLoading" class="modal-loading">
            <div class="spinner large"></div>
            <span>内容加载中...</span>
          </div>
          <iframe
            ref="modalIframe"
            :src="currentVideoSrc"
            frameborder="0"
            style="width: 100%; height: 100%"
            class="iframe-content"
            @load="handleModalLoad"
          ></iframe>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import userAvatar from '@/assets/user.png'
  import aiAvatar from '@/assets/ai.png'
  import axios from "axios"
  const { marked } = require('marked')

  export default {
    data() {
      return {
        userAvatar,
        aiAvatar,
        question: '',
        isSending: false,
        currentAIMessage: '',
        typingText: '',
        typingIndex: 0,
        typingTimer: null,
        messages: [],
        vrList: [],
        videoList: [],
        showVideo: false,
        currentVideoSrc: '',
        currentVideoTitle: '',
        modalLoading: true,
        questions: [
          { color: 'blue', text: '节流调速回路中，节流阀和调速阀各有什么特点？' },
          { color: 'pink', text: '简述单活塞杆液压缸的基本工作原理' },
          { color: 'green', text: '请描述径向柱塞泵的工作原理，并说明其结构特点及局限性' },
          { color: 'blue', text: '双作用叶片泵的工作原理是什么？它与单作用叶片泵的主要区别在哪里？' },
        ],
        showRefreshBtn: false, // 是否显示刷新按钮
        currentErrorQuery: '', // 记录出错的查询文本，用于重新请求
        isChatCompleted: false // AI回答是否完成（控制资源显示）
      }
    },
    mounted() {
      // 初始化懒加载
      this.initLazyLoad();
    },
    methods: {
      refreshChat() {
        if (!this.currentErrorQuery) return;
        // 1. 隐藏刷新按钮
        this.showRefreshBtn = false;
        // 2. 重新发送请求（复用handleSend逻辑，但直接使用记录的查询文本）
        this.question = this.currentErrorQuery;
        this.handleSend();
      },
      initLazyLoad() {
        // 选择所有带lazy-load类的图片
        const lazyImages = document.querySelectorAll('.lazy-load');

        // 监听图片是否进入可视区域
        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) { // 图片进入可视区域
              const img = entry.target;
              const src = img.getAttribute('data-src');
              // 加载图片
              img.src = src;
              // 加载完成后移除监听（避免重复触发）
              observer.unobserve(img);
              // 可选：加载失败时显示默认图
              img.onerror = () => {
                img.src = '@/assets/default-img.png'; // 提前准备一张默认占位图
              };
            }
          });
        }, {
          rootMargin: '200px 0px' // 提前200px开始加载，提升感知速度
        });

        // 对每个图片添加监听
        lazyImages.forEach(img => observer.observe(img));
      },
      scrollResource(type, direction) {
        const ref = type === 'video' ? this.$refs.videoScroll : this.$refs.vrScroll;
        if (ref) {
          const container = ref;
          const scrollAmount = 300; // 每次滑动的距离
          container.scrollBy({ left: direction * scrollAmount, behavior: 'smooth' });
        }
      },
      handleQuickQuestion(text) {
        this.question = text;
      },
      handleKeydown(e) {
        if (e.key === 'Enter' && !e.shiftKey) {
          e.preventDefault();
          this.handleSend();
        }
      },
      scrollToBottom() {
        this.$nextTick(() => {
          const box = this.$refs.chatBox;
          if (box) box.scrollTop = box.scrollHeight;
        });
      },
      async handleSend() {
        const input = this.question.trim();
        if (!input || this.isSending) return;
        this.isChatCompleted = false;
        this.messages.push({ type: 'user', content: input, timestamp: new Date() });
        this.messages.push({ type: 'ai', content: '小明正在思考中...', timestamp: new Date() });
        this.question = '';
        this.isSending = true;
        this.currentAIMessage = '';
        this.scrollToBottom();

        await Promise.all([
          this.requestAgent('chat', input, 3),
          this.requestAgent('vr', input, 2),
          this.requestAgent('video', input, 1)
        ]);
      },
      async requestAgent(type, text, flag) {
        try {
          const res = await axios.post('/chat', {
            query: text,
            user: "abc-123",
            type: flag
          });

          if (type === 'chat') {
            this.showRefreshBtn = false;
            this.currentErrorQuery = '';
            // 处理chat类型的响应数据
            var responseData = JSON.parse(
              res.data.slice(5).trim()
                .replace("'", '"')
                .replace(/\\\\/g, '\\')
            ).content;

// 预处理：仅处理代码块标记，保留Markdown原生换行和标题符号
            let processedData = responseData
              .replace(/```json/g, '<pre class="code"><code>') // 代码块开始
              .replace(/```/g, '</code></pre>'); // 代码块结束

// 关键：先让marked解析Markdown（此时保留换行符，不替换为<br>）
            let htmlContent = marked(processedData);

// 解析后再处理必要的HTML微调（如换行、间距等，可选）
            htmlContent = htmlContent
              .replace(/\n{2,}/g, '<br><br>') // 多换行转段落间隔（解析后处理）
              .replace(/<li>/g, '<li style="margin: 0.3em 0;">'); // 列表项间距（示例）

// 传入打字效果函数
            this.startTyping(htmlContent);
          }

          if (type === 'vr' || type === 'video') {
            var responseData = JSON.parse(JSON.parse(res.data.slice(5).trim().replace(/^"|"$/g, '').replace(/\\\\/g, '\\')).content).answer
            const mapped = responseData.map(i => ({
              title: i.data2 || '',
              path: (i.data4 || '').replace('http://keming365.com/user/showPPT', 'https://yq.keming365.com/webclient').replace('http://', 'https://'),
              img: (i.data3 || '').replace('http:', 'https:')
            })).filter(i => i.title && i.path && i.img);

            if (type === 'vr') this.vrList = mapped;
            if (type === 'video') this.videoList = mapped;
          }

        } catch (err) {
          this.isSending = false;
          if (type === 'chat') {
            // 1. 更新AI消息为“服务器繁忙”
            const lastMsg = this.messages[this.messages.length - 1];
            if (lastMsg && lastMsg.type === 'ai') {
              lastMsg.content = '服务器繁忙，请点击刷新重试';
            }
            // 2. 显示刷新按钮，并记录当前查询文本（用于重新请求）
            this.showRefreshBtn = true;
            this.currentErrorQuery = text; // 保存当前查询内容
          }
          console.error('请求失败', err);
        }
      },
      startTyping(fullText) {
        this.currentAIMessage = '';
        this.typingText = fullText;
        this.typingIndex = 0;

        if (this.typingTimer) clearInterval(this.typingTimer);

        this.typingTimer = setInterval(() => {
          if (this.typingIndex < this.typingText.length) {
            this.currentAIMessage += this.typingText[this.typingIndex++];
            this.scrollToBottom();
          } else {
            clearInterval(this.typingTimer);
            this.typingTimer = null;
            this.isSending = false;

            const last = this.messages[this.messages.length - 1];
            if (last && last.type === 'ai') {
              last.content = this.typingText;
            }

            this.currentAIMessage = '';

            this.isChatCompleted = true;
          }
        }, 20);
      },
      formatMessage(text) {
        if (!text) return '';
        // 1. 先处理代码块标记（保持原样）
        let formatted = text
          .replace(/```json/g, '<pre class="code"><code>')
          .replace(/```/g, '</code></pre>');
        // 2. 先让marked解析Markdown（此时保留换行符，不替换为<br/>）
        let html = marked(formatted);
        // 3. 如需额外处理换行，可在解析后进行（可选，根据需求）
        // html = html.replace(/\n/g, '<br/>');
        return html;
      },
      formatTime(ts) {
        const d = new Date(ts);
        const h = d.getHours().toString().padStart(2, '0');
        const m = d.getMinutes().toString().padStart(2, '0');
        return `${h}:${m}`;
      },
      openUrl(path, title = '资源预览') {
        this.currentVideoSrc = path;
        this.currentVideoTitle = title;
        this.modalLoading = true;
        this.showVideo = true;
      },
      handleModalLoad() {
        this.modalLoading = false;
      },
      closeModal() {
        this.showVideo = false;
        this.currentVideoSrc = '';
        this.currentVideoTitle = '';
      },
      toggleFullscreen() {
        const iframe = this.$refs.modalIframe;
        if (iframe.requestFullscreen) iframe.requestFullscreen();
        else if (iframe.webkitRequestFullscreen) iframe.webkitRequestFullscreen();
        else if (iframe.mozRequestFullScreen) iframe.mozRequestFullScreen();
        else if (iframe.msRequestFullscreen) iframe.msRequestFullscreen();
      }
    },
    beforeDestroy() {
      if (this.typingTimer) {
        clearInterval(this.typingTimer);
        this.typingTimer = null;
      }
    }
  }
</script>

<style scoped>
  .container {
    font-family: 'Segoe UI', sans-serif;
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;
  }

  /* 对话历史样式 */
  .chat-history {
    height: 400px;
    overflow-y: auto;
    margin-bottom: 20px;
    padding: 10px;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
  }

  .message {
    display: flex;
    margin-bottom: 20px;
  }

  .message-user {
    flex-direction: row-reverse; /* 用户消息右对齐 */
  }

  .avatar {
    width: 40px;
    height: 40px;
    margin: 0 10px;
    flex-shrink: 0; /* 防止头像被压缩 */
  }

  .avatar img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    object-fit: cover;
  }

  .content {
    max-width: 70%;
    padding: 12px 16px;
    border-radius: 12px;
    word-wrap: break-word; /* 长文本换行 */
  }

  .message-user .content {
    background-color: #646cff;
    color: white;
    margin-left: auto; /* 右对齐 */
  }

  .message-ai .content {
    background-color: #f3f4f6;
    color: #111827;
    margin-right: auto; /* 左对齐 */
  }

  .text {
    margin-bottom: 6px;
    line-height: 1.5;
    font-size: 15px;
  }

  .time {
    font-size: 12px;
    color: #9ca3af;
    text-align: right;
    margin-top: 4px;
  }

  /* 输入区域样式 */
  .input-box {
    background: #ffffff;
    border-radius: 10px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  }

  /* 提问提示区域 */
  .prompt-box {
    background: #f8f9fa;
    border-radius: 10px 10px 0 0;
    padding: 15px;
    border-bottom: 1px solid #e5e7eb;
  }

  .prompt-box h3 {
    margin: 0 0 10px 0;
    color: #374151;
    font-size: 16px;
  }

  .question-list {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .question-list li {
    display: flex;
    align-items: center;
    padding: 10px 0;
    border-bottom: 1px solid #e5e7eb;
    cursor: pointer;
    transition: background 0.2s;
    font-size: 14px;
    color: #4b5563;
  }

  .question-list li:last-child {
    border-bottom: none; /* 最后一项不显示底部分隔线 */
  }

  .question-list li:hover {
    background-color: #f3f4f6;
  }

  .dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin-right: 10px;
    flex-shrink: 0; /* 防止圆点被压缩 */
  }

  .blue { background-color: #646cff; }
  .pink { background-color: #ff6b9c; }
  .green { background-color: #4caf50; }

  .arrow-icon {
    margin-left: auto;
    width: 10px;
  }

  /* 输入文本框样式 */
  textarea {
    width: 100%;
    border: none;
    resize: none;
    background: transparent;
    padding: 15px;
    font-size: 16px;
    margin-bottom: 0;
    transition: background 0.2s;
  }

  textarea:focus {
    outline: none;
    background: #f8f9fa;
  }

  /* 控制栏样式 */
  .control {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 15px 15px;
  }

  .switch {
    display: flex;
    align-items: center;
    gap: 10px;
    color: #6b7280;
    font-size: 14px;
  }

  .switch input {
    /* 隐藏默认复选框 */
    appearance: none;
    width: 36px;
    height: 20px;
    background: #e5e7eb;
    border-radius: 10px;
    position: relative;
    cursor: pointer;
    transition: background 0.2s;
  }

  .switch input:checked {
    background: #646cff;
  }

  .switch input::after {
    content: '';
    position: absolute;
    top: 2px;
    left: 2px;
    width: 16px;
    height: 16px;
    background: white;
    border-radius: 50%;
    transition: left 0.2s;
  }

  .switch input:checked::after {
    left: 18px;
  }

  .send-btn {
    background: #646cff;
    border: none;
    border-radius: 6px;
    padding: 8px 16px;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: opacity 0.2s;
    font-size: 14px;
  }

  .send-btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  .send-btn svg {
    width: 18px;
    height: 18px;
    fill: white;
    margin-left: 8px;
  }

  /* 免责声明样式 */
  .disclaimer {
    text-align: center;
    font-size: 12px;
    color: #9ca3af;
    margin-top: 10px;
    padding: 0 10px;
  }

  .message-bubble.ai.typing::after {
    content: '|';
    animation: blink 1s steps(1) infinite;
    margin-left: 4px;
    color: #888;
  }

  @keyframes blink {
    0%, 50%, 100% { opacity: 1; }
    25%, 75% { opacity: 0; }
  }

  /* 模态框相关样式 */
  .modal-mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1001;
  }
  .modal-container {
    width: 95%;
    max-width: 1024px;
    background: white;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.15);
  }
  .modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 24px;
    background: #1e293b;
    color: white;
  }
  .modal-title {
    font-size: 1.25rem;
    font-weight: 500;
  }
  .modal-actions {
    display: flex;
    gap: 12px;
  }
  .modal-actions button {
    background: none;
    border: none;
    color: white;
    cursor: pointer;
  }
  .modal-actions button:hover {
    color: #ff4757;
  }
  .modal-content {
    height: 60vh;
    min-height: 400px;
    padding: 24px;
    background: #f8f9fa;
  }
  .modal-loading {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
  .spinner.large {
    width: 40px;
    height: 40px;
    border: 4px solid #ccc;
    border-top-color: #1e90ff;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin-bottom: 10px;
  }
  @keyframes spin {
    to { transform: rotate(360deg); }
  }

  /* VR/视频卡片区域样式（你已有，可合并） */
  .resource-row {
    display: flex;
    justify-content: space-between;
    gap: 16px;
    margin-top: 20px;
  }

  .resource-block {
    flex: 1;
    min-width: 0;
    background: #f9f9f9;
    padding: 12px;
    border-radius: 8px;
    box-shadow: 0 0 6px rgba(0,0,0,0.05);
    display: flex;
    flex-direction: column;
  }

  .section-title {
    font-size: 14px;
    margin-bottom: 6px;
    font-weight: bold;
    color: #333;
  }

  .scroll-wrapper {
    display: flex;
    align-items: center;
  }

  .scroll-container {
    display: flex;
    overflow-x: auto;
    gap: 20px;
    flex: 1;
    padding-bottom: 6px;
    overflow: hidden;
  }

  .resource-card {
    width: 160px;
    flex-shrink: 0;
    background: white;
    border-radius: 8px;
    box-shadow: 0 1px 4px rgba(0,0,0,0.08);
    cursor: pointer;
    transition: transform 0.2s;
  }

  .resource-card:hover {
    transform: scale(1.05);
  }

  .card-image {
    width: 100%;
    height: 80px;
    object-fit: cover;
    border-radius: 8px 8px 0 0;
  }

  .card-title {
    padding: 6px;
    font-size: 12px;
    text-align: center;
    color: #444;
    /* 以下为新增样式 */
    white-space: nowrap; /* 强制单行显示 */
    overflow: hidden; /* 超出部分隐藏 */
    text-overflow: ellipsis; /* 溢出显示省略号 */
    width: 100%; /* 确保宽度充满容器 */
    box-sizing: border-box; /* 包含padding计算宽度 */
  }

  .scroll-btn {
    background: none;
    border: none;
    font-size: 20px;
    cursor: pointer;
    color: #999;
    padding: 4px;
  }

  .scroll-btn:hover {
    color: #333;
  }

  /* 穿透scoped限制（如果使用Vue单文件组件的scoped） */
  ::v-deep .message .content {
    line-height: 1.7;
    font-size: 15px;
    color: #333;
  }

  /* 标题样式（增强优先级） */
  ::v-deep .message .content h1,
  ::v-deep .message .content h2,
  ::v-deep .message .content h3,
  ::v-deep .message .content h4,
  ::v-deep .message .content h5,
  ::v-deep .message .content h6 {
    font-weight: 600 !important; /* 强制覆盖粗体 */
    margin: 1.2em 0 0.6em !important;
    color: #222 !important;
    border-bottom: 1px solid #eee !important;
    padding-bottom: 0.2em !important;
    line-height: 1.3 !important; /* 标题行高单独设置 */
  }

  /* 精确控制标题字体大小（覆盖默认超大尺寸） */
  ::v-deep .message .content h1 { font-size: 1.5em !important; }
  ::v-deep .message .content h2 { font-size: 1.3em !important; }
  ::v-deep .message .content h3 { font-size: 1.2em !important; }
  ::v-deep .message .content h4 { font-size: 1.1em !important; }
  ::v-deep .message .content h5,
  ::v-deep .message .content h6 { font-size: 1em !important; }

  /* 段落样式 */
  ::v-deep .message .content p {
    margin: 0.8em 0 !important;
    text-align: justify !important;
    font-size: 15px !important; /* 确保段落文字大小一致 */
  }

  /* 列表样式 */
  ::v-deep .message .content ul,
  ::v-deep .message .content ol {
    margin: 0.8em 0 !important;
    padding-left: 1.5em !important;
  }

  ::v-deep .message .content ul { list-style-type: disc !important; }
  ::v-deep .message .content ol { list-style-type: decimal !important; }

  ::v-deep .message .content li {
    margin: 0.3em 0 !important;
    font-size: 15px !important;
  }

  /* 代码块样式 */
  ::v-deep .message .content pre.code {
    background-color: #f8f9fa !important;
    border-radius: 6px !important;
    padding: 12px !important;
    margin: 1em 0 !important;
    overflow-x: auto !important;
    font-size: 0.9em !important;
    line-height: 1.5 !important;
    border: 1px solid #e5e7eb !important;
  }

  ::v-deep .message .content code {
    font-family: Consolas, Monaco, 'Andale Mono', monospace !important;
    color: #c7254e !important;
    background-color: #f9f2f4 !important;
    padding: 0.2em 0.4em !important;
    border-radius: 3px !important;
  }

  /* 表格样式 */
  ::v-deep .message .content table {
    width: 100% !important;
    margin: 1em 0 !important;
    border-collapse: collapse !important;
  }

  ::v-deep .message .content th,
  ::v-deep .message .content td {
    padding: 8px 12px !important;
    border: 1px solid #ddd !important;
    font-size: 14px !important;
  }

  ::v-deep .message .content th {
    background-color: #f5f5f5 !important;
    font-weight: 600 !important;
  }

  /* 引用样式 */
  ::v-deep .message .content blockquote {
    border-left: 4px solid #646cff !important;
    padding-left: 1em !important;
    margin: 1em 0 !important;
    color: #666 !important;
    background-color: #f8f9fa !important;
  }

  /* 链接样式 */
  ::v-deep .message .content a {
    color: #646cff !important;
    text-decoration: none !important;
  }

  ::v-deep .message .content a:hover {
    text-decoration: underline !important;
  }

  /* 图片样式 */
  ::v-deep .message .content img {
    max-width: 100% !important;
    height: auto !important;
    margin: 1em 0 !important;
    border-radius: 4px !important;
  }

  /* 刷新按钮样式 */
  ::v-deep .content {
    position: relative; /* 让按钮相对于内容区定位 */
  }

  ::v-deep .refresh-btn {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    background: none;
    border: none;
    color: #646cff;
    cursor: pointer;
    padding: 4px;
    opacity: 0.8;
  }

  ::v-deep .refresh-btn:hover {
    opacity: 1;
    transform: translateY(-50%) scale(1.1);
    transition: all 0.2s;
  }
</style>




// WEBPACK FOOTER //
// src/components/tp/KmaiPage.vue